<kv-editor-container [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups" [inputComponent]="inputComponent"></kv-editor-container>
<!--     <ng-template editorContentTemplate [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups" [inputComponent]="inputComponent">
    </ng-template>
</kv-editor-container> -->

<!-- <div kvCollapseSubmenu>
    <p>Shit's going down el se</p>
</div> -->
<!-- <kv-editor-input-container editor>
    <ng-template editorInputTemplate [inputComponent]="inputComponent">
    </ng-template>
</kv-editor-input-container>  -->

